<template>
  <div>
	  <Header :sel="2" @changePhone="changePhone"/>
	  <div :class="['cd-main-content',showPhone?'nav-is-visible':'']">
	    <!-- your content here --> 
	    <!--banner-->
	    <div class="banner">
	      <div class="banner_txt">
	        <p><strong>About us</strong></p>
	        <p>关于我们</p>
	      </div>
	    </div>
	    <!--banner--> 
	    
	    <!--neirong-->
	    <div class="neirong">
	      <div class="bread"> <a href="javascript:void(0)" @click="go('/')">首页</a> - <a href='javascript:void(0)'>关于我们</a> - <a href='javascript:void(0)'>{{detail.title}}</a></div>
	      <div class="neirong_c">
	        <ul class="erji_tab">
	          <li v-for="item in tabList"><a href='javascript:void(0)' :class="item.id==selId?'sel10':''" @click="selData(item.id)">{{item.name}}</a></li>
	        </ul>
	        <p align="center"><img :src="detail.image" /></p>
	        <p v-html="detail.cmsArticleData?detail.cmsArticleData.content:''"></p>
	      </div>
	    </div>
		 <Footer></Footer>
		</div>
		 
	  
   
  </div>
</template>

<script>
	import Header from '@/components/header.vue'
	import Footer from '@/components/footer.vue'
	import{articleDetail} from '@/api/reqFetch.js'
  export default {
  	name: '',
    layout: '',
	components: {
	  Footer,
	  Header
	},
  	data() {
  		return {
			selId: '1665618104755376128',
			detail:{},
			tabList:[{
				name:'公司介绍',
				id:'1665618104755376128'
			},{
				name:'企业文化',
				id:'1665618176524111872'
			},{
				name:'荣誉资质',
				id:'1665618228105662464'
			}],
			showPhone:false
		}
  	},

  	mounted() {
  	
	 if(this.$route.query.id){
		 this.selId=this.$route.query.id
	 }
	  this.getData()
  	},
	

  	methods: {
		go(url){
			if(this.$route.fullPath!=url){
				this.$router.push(url)
				
			}
		},
		changePhone(val){
			this.showPhone=val
		},
		selData(id){
			this.selId=id
			this.getData()
		},
		getData(){
			articleDetail({id:this.selId}).then(res => {	  
			    this.detail = res.data;
			});
		},
		
	
     
  	}
  }
</script>

<style scoped>
	.banner{
		background-image: url('../../assets/images/banner_02.png');
	}
</style>
